var map = {
	"./000-Nothing-at-all.png": 657,
	"./001-Clear.png": 658,
	"./001-Just-Noticeable.png": 659,
	"./001-Present.png": 660,
	"./002-Occasional.png": 661,
	"./002-Very-Slight.png": 662,
	"./002-White.png": 663,
	"./003-Persistent.png": 664,
	"./003-Slight.png": 665,
	"./003-Tan.png": 666,
	"./004-Chronic.png": 667,
	"./004-Moderate.png": 668,
	"./004-Yellow.png": 669,
	"./005-Green.png": 670,
	"./005-Some-Difficulty.png": 671,
	"./006-Brown.png": 672,
	"./006-Severe.png": 673,
	"./007-Bloody.png": 674,
	"./007-Very-Severe.png": 675,
	"./008-Almost-Maximal.png": 676,
	"./008-Blood-Tinged.png": 677,
	"./009-Maximal.png": 678,
	"./010-Panic-Level.png": 679,
	"./Green-Check.png": 680,
	"./Sputum-Color/001-Clear.png": 681,
	"./Sputum-Color/002-White.png": 682,
	"./Sputum-Color/003-Tan.png": 683,
	"./Sputum-Color/004-Yellow.png": 684,
	"./Sputum-Color/005-Green.png": 685,
	"./Sputum-Color/006-Brown.png": 686,
	"./Sputum-Color/007-Bloody.png": 687,
	"./Sputum-Color/008-Blood-Tinged.png": 688,
	"./Symptoms/001-Present.png": 689,
	"./Symptoms/002-Occasional.png": 690,
	"./Symptoms/003-Persistent.png": 691,
	"./Symptoms/004-Chronic.png": 692,
	"./iconsData": 381,
	"./iconsData.js": 381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 305;